import { render, staticRenderFns } from "./AccettazioneSsnListaComponentNew.vue?vue&type=template&id=16c1bef9&scoped=true"
import script from "./AccettazioneSsnListaComponentNew.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaComponentNew.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnListaComponentNew.vue?vue&type=style&index=0&id=16c1bef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c1bef9",
  null
  
)

export default component.exports